var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlackRoundedTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04945 8.0375L5.1677 10.8689l7.01838-7.2",
    stroke: "#000",
    strokeWidth: 1.8,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  })));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/black-rounded-tick.svg";
export { SvgBlackRoundedTick as ReactComponent };